module.exports = __webpack_public_path__ + "static/media/replayer_tv_red.5c29b298.svg";